export default __webpack_public_path__ + "static/media/portfolio-214.1fd3e7aa.jpg";